import { LogoutPage } from 'module/authentication/components/logout';

export const Logout = () => {
  return <LogoutPage postLogoutUrl="/login" />;
};
